module.exports = __webpack_public_path__ + "static/media/eccomerce.44944b05.png";